module.exports = __webpack_public_path__ + "static/media/signal-1.fd81cc6b.svg";